module.exports = __webpack_public_path__ + "static/media/services_beauty.a3d29b65.jpg";